import React from 'react'
import { connect } from 'react-redux'
import { addListItem, changeListItem, deleteListItem, getListFromValues, hasChangedValues, getFormValue, changeItemsValue, getListItems } from '../../../public/utility'
import { concat } from 'lodash'
import EvaluationApplicationDiv from './EvaluationApplicationDiv'
class AddEvaluationApplicationDiv extends React.Component {
    state = {}
    componentDidMount = () => {
        Tyan.doPostEvent({
            event: 'GetEvaluateItemOption',
            data: {},
            onEnd: ({ errorMessage, optionsParas }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                    return
                }
                this.setState({ optionsParas, initValues基本信息: {}, changedValues基本信息: {} })
            }
        })
    }

    handlerSave = () => {
        const { onClose, onSave, showDetail } = this.props
        const { changedValues基本信息 } = this.state
        Tyan.doPostEvent({
            event: 'CreateEvaluationApplication',
            data: { changedValues基本信息 },
            onEnd: ({ errorMessage, id }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                    return
                }
                onClose && onClose()
                showDetail(props => <EvaluationApplicationDiv {...props} id={id} onSave={() => onSave()} />)
            }
        })
    }

    handlerClose = () => {
        const { onClose } = this.props
        if (!this.bChanged()) {
            onClose && onClose()
            return
        }
        Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
    }

    canSave = () => {
        return getFormValue(this, '基本信息', '评价项目名称')
    }

    bChanged = () => {
        return hasChangedValues(this)
    }

    fieldset基本信息 = () => {
        return [
            { _select: '评价项目名称', minWidth: '95%', edit: true, required: true }
        ]
    }

    render() {
        const { showMessage: Message, showBody: Body, id } = this.props
        const { errorMessage, initValues基本信息, bReadOnly } = this.state
        if (!initValues基本信息) return <Message text={'请稍等 ...'} />
        if (errorMessage) return <Message text={errorMessage} />
        const canSave = this.canSave()
        const bChanged = this.bChanged()
        return <Body data={this} maxWidth="700"
            controls={
                bReadOnly ?
                    [
                        { _button: bChanged && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
                    ] : [
                        { _button: '保存', icon: 'save', handler: this.handlerSave, disabled: !(canSave && bChanged) },
                        { _button: bChanged ? '取消' : '关闭', icon: 'close', handler: this.handlerClose },
                    ]}
            fieldsets={
                [
                    { title: '', name: '基本信息', _fieldset: this.fieldset基本信息(), disabled: bReadOnly },
                ]}
        />
    }
}

export default connect()(AddEvaluationApplicationDiv)